/** Lädt Theme-CSS und Favicon neu, nachdem im Admin-Bereich etwas geändert wurde. */
export function refreshTheme(): void {
  const stamp = Date.now();
  const css = document.querySelector<HTMLLinkElement>('link[rel="stylesheet"][href^="/theme/theme.css"]');
  if (css) css.href = `/theme/theme.css?v=${stamp}`;
  const icon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (icon) icon.href = `/theme/favicon?v=${stamp}`;
}
